import React, { Component } from 'react';

import Blank from '../../../hoc/Blank/Blank';
import Button from '../../UI/Button/Button';

class DeleteWarningModal extends Component {
    render () {
        return (
            <Blank>
                <h3>Delete Order Warning</h3>
                <p>Please confirm that you would like to 
                <br />delete this order
                </p>                
                <Button btnType="Success" clicked={this.props.delete}>DELETE</Button>  <Button btnType="Danger" clicked={this.props.cancel}>CANCEL</Button>
            </Blank>
        );
    }
}

export default DeleteWarningModal;


// WEBPACK FOOTER //
// ./src/components/SuccessModals/DeleteWarningModal/DeleteWarningModal.js